<template>
    <div>
        <!-- Desktop Sidebar (> 600px) -->
        <v-navigation-drawer
            v-if="!$vuetify.breakpoint.xsOnly"
            v-model="drawer"
            :color="theming.sideBarColor || 'ffffff'"
            fixed
            :permanent="shouldDrawerBePermanent"
            class="drawer pt-14"
            :width="drawer? '190px' : '60px'"
        >
            <v-list
                nav
                dense
            >
                <div v-for="(menuItem, index) in filteredMenu" :key="index" @click="setDrawer">
                    <v-list-item :to="menuItem.to" link>
                        <v-list-item-icon v-if="menuItem.icon" class="mr-3 mb-3 mt-3">
                            <v-icon class="sidebar-icon" :color="menuItem.color ? menuItem.color : 'grey'" size="28">{{ menuItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-if="menuItem.title" :color="theming.sideBarText || 'black'"><span class="menu-item">{{ menuItem.title }}</span></v-list-item-title>
                    </v-list-item>
                </div>
            </v-list>
            <template v-if="drawer" v-slot:append>
                <div class="powered-by-wrapper" :color="theming.sideBarText || 'black'">
                    <span class="powered-by">
                        developed by
                    </span>
                    <span class="powered-by-name" @click="onNameClick">
                        Karageorgos Dimitris
                    </span>
                </div>
            </template>
        </v-navigation-drawer>

        <!-- Mobile Bottom Menu (< 600px) -->
        <transition name="slide-up">
            <div
                v-if="$vuetify.breakpoint.xsOnly && drawer"
                v-click-outside="closeMobileMenu"
                class="mobile-bottom-menu"
                :style="{ background: `linear-gradient(to top, ${theming.sideBarColor || '#ffffff'}, color-mix(in srgb, ${theming.sideBarColor || '#ffffff'} 85%, black))` }"
            >
                <v-list nav dense class="pa-0 mobile-list">
                    <div v-for="(menuItem, index) in filteredMenu" :key="index">
                        <v-divider v-if="index > 0" class="mobile-divider" />
                        <v-list-item
                            :to="menuItem.to"
                            link
                            class="mobile-list-item"
                            @click="closeMobileMenu"
                        >
                            <v-list-item-icon v-if="menuItem.icon" class="my-2">
                                <v-icon class="sidebar-icon" :color="menuItem.color ? menuItem.color : 'grey'" size="26">{{ menuItem.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title v-if="menuItem.title"><span class="menu-item menu-item-mobile">{{ menuItem.title }}</span></v-list-item-title>
                        </v-list-item>
                    </div>
                </v-list>
            </div>
        </transition>
    </div>
</template>

<script>
    import jwtUtil from '@/utils/jwtUtil'
    export default {
        name: 'Sidebar',
        data() {
            return {
                menu: [
                    {
                        title: 'Αναθέσεις',
                        to: '/assignments',
                        icon: 'mdi-clipboard-arrow-down-outline',
                        color: '#0047AB'
                    },
                    {
                        title: 'Εμφυσήσεις',
                        to: '/blowing',
                        icon: 'mdi-clipboard-clock-outline',
                        color: '#C59DC2',
                        roles: ['ROLE_BLOWER'],
                        show: false
                    },
                    {
                        title: 'Κολλήσεις',
                        to: '/welding',
                        icon: 'mdi-clipboard-clock-outline',
                        color: '#AAB8BB',
                        roles: ['ROLE_WELDER'],
                        show: false
                    },
                    {
                        title: 'Στατιστικά',
                        to: '/stats',
                        icon: 'mdi-finance',
                        color: 'green',
                        roles: ['ROLE_ADMIN']
                    },
                    {
                        title: 'Χρήστες',
                        to: '/users',
                        color: '#FFC000',
                        icon: 'mdi-account-multiple-outline',
                        roles: ['ROLE_ADMIN', 'ROLE_CONTRACTOR']
                    },
                    {
                        title: 'Αποθήκη',
                        to: '/storage',
                        color: '#9F2B68',
                        icon: 'mdi-warehouse',
                        roles: ['ROLE_ADMIN'],
                        show: false
                    },
                    {
                        title: 'Καμπίνες',
                        to: '/cabins',
                        color: '#530066',
                        icon: 'mdi-file-cabinet',
                        show: false
                    },
                    {
                        title: 'Ημερολόγιο',
                        to: '/calendar',
                        icon: 'mdi-calendar',
                        color: 'grey',
                        show: false
                    }
                ],
                width: 0,
                height: 0
            }
        },
        watch: {
            config: {
                handler(newVal, oldVal) {
                    if (!newVal) {
                        return
                    }
                    if (newVal.hasStorage) {
                        const item = this.menu.find(menuItem => menuItem.to === '/storage')
                        item.show = true
                    }
                    if (newVal.hasCalendar) {
                        const item = this.menu.find(menuItem => menuItem.to === '/calendar')
                        item.show = true
                    }
                    if (newVal.hasCabins) {
                        const item = this.menu.find(menuItem => menuItem.to === '/cabins')
                        item.show = true
                    }
                    if (newVal.hasBuckets) {
                        const items = this.menu.filter(menuItem => menuItem.to === '/blowing' || menuItem.to === '/welding')
                        for (const item of items) {
                            item.show = true
                        }
                    }
                    this.menu = [ ...this.menu ]
                },
                immediate: true
            }
        },
        computed: {
            config() {
                return this.$store.getters.getConfig || {}
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            },
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken) || []
            },
            shouldDrawerBePermanent() {
                if (this.width < 950) {
                    return false
                }
                return true
            },
            filteredMenu() {
                return this.menu.filter(menuItem => {
                    const hasRoles = !menuItem.roles ||
                        this.isAdminOrCompanyCoordinator ||
                        (this.containsAny(menuItem.roles, this.userRoles) && !['/blowing', '/welding'].includes(menuItem.to)) ||
                        (menuItem.to === '/blowing' && this.isCompanyBlower) ||
                        (menuItem.to === '/welding' && this.isCompanyWelder)
                    return hasRoles && menuItem.show !== false
                })
            }
        },
        mounted() {
            this.width = window.innerWidth
            this.height = window.innerHeight
            window.addEventListener('resize', this.onScreenResize)
            if (this.$vuetify.breakpoint.xsOnly) {
                this.$store.dispatch('setDrawer', false)
            }
        },
        methods: {
            onNameClick() {
                window.open('https://karageorgos-dimitris.com', '_blank').focus()
            },
            onScreenResize() {
                this.width = window.innerWidth
                this.height = window.innerHeight
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            setDrawer() {
                this.$store.dispatch('setDrawer', !this.drawer)
            },
            closeMobileMenu() {
                if (this.$vuetify.breakpoint.xsOnly && this.drawer) {
                    this.$store.dispatch('setDrawer', false)
                }
            },
            include() {
                return [document.querySelector('.included')]
            }
        }
    }
</script>

<style scoped>
.drawer {
    box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
    background: linear-gradient(to bottom, var(--sidebar-color), color-mix(in srgb, var(--sidebar-color) 85%, black));
}
.mobile-bottom-menu {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    max-height: 60vh;
    padding: 1.5rem;
    overflow-y: auto;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    box-shadow: 0px -7px 20px rgba(0, 0, 0, 0.2);
    padding-bottom: env(safe-area-inset-bottom, 8px);
    background-color: transparent;
}
.mobile-list-item {
    min-height: 52px !important;
    display: flex;
    justify-content: center !important;
    align-items: center;
    background-color: transparent;
}

.mobile-list {
    background-color: transparent;
}

.mobile-divider {
    border-color: rgba(128, 128, 128, 0.15) !important;
    margin: 0 5px;
}
.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.25s ease, opacity 0.25s ease;
}
.slide-up-enter,
.slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
}
.sidebar-icon {
    filter: drop-shadow(1px 0.5px 0.5px rgba(0, 0, 0, 0.4));
}
a {
    color: #0060B6;
    text-decoration: none;
}

a:hover {
    color:#00A0C6;
    text-decoration:none;
    cursor:pointer;
}
.sub-text{
    font-size: 0.8rem;
    color: black;
}
.container {
    align-self: center;
    height: 100%;
}

.menu-item {
    font-size: 1rem;
    color: var(--sidebar-text-color);
}

.menu-item-mobile {
    font-size: 1.2rem;
    color: var(--sidebar-text-color);
}

.v-list-item__icon {
    align-self: center;
}

.powered-by-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.powered-by {
    font-size: 0.7rem;
    color: var(--sidebar-text-color);
    padding-right: 3.7rem;
}

.powered-by-name {
    font-size: 0.85rem;
    color: var(--sidebar-text-color);
    cursor: pointer;
}

.powered-by-name:hover {
    color: #01aebe
}
</style>
